export enum ComponentType {
    NavBar = 'navbar',
    Hero = 'hero',
    ContactForm = 'contact-form',
    FeatureBanner = 'feature-banner',
    CardsGallery = 'cards-gallery',
    CardsSideBySide = 'cards-side-by-side',
    GoogleMaps = 'google-maps',
    GoogleReviews = 'google-reviews',
    AboutUs = 'about-us',
    ServiceDetails = 'service-details',
    ImageGallery = 'image-gallery',
}

export enum ComponentActions {
    EditGallery = 'edit gallery',
}

export enum ElementsType {
    Text = 'text',
    Image = 'image',
    Button = 'button',
    ComponentHeader = 'component-header',
    ComponentImageText = 'comp-image-text',
    FeatureBanner = 'feature-banner',
    BaseCard = 'base-card',
    BaseReview = 'base-review',
    ServiceDetails = 'service-details',
    ImprintTemplate = 'imprint-template',
    GalleryConfig = 'gallery-config',
}

export enum StyleType {
    Color = 'color',
    FontSize = 'font-size',
    FontWeight = 'font-weight',
    TextAlign = 'text-align',
    BackgroundColor = 'background-color',
    Border = 'border',
}

export enum ButtonActionType {
    Navigate = 'navigate',
    ScrollTo = 'scrollTo',
    NavigateAndScrollTo = 'navigateAndScrollTo',
    // OpenModal = 'openModal',
    // Custom = 'custom', // Für benutzerdefinierte Aktionen
}

export const ButtonActionDisplayNames: Record<ButtonActionType, string> = {
    [ButtonActionType.Navigate]: 'Navigieren',
    [ButtonActionType.ScrollTo]: 'Scrollen',
    [ButtonActionType.NavigateAndScrollTo]: 'Navigieren und scrollen',
    // [ButtonActionType.OpenModal]: 'Modal öffnen',
    // [ButtonActionType.Custom]: 'Benutzerdefiniert',
};

export enum ModeType {
    Edit = 'edit',
    View = 'view'
}

export enum FontFamily {
    Roboto = 'Roboto, sans-serif',
    Nunito = 'Nunito, sans-serif',
    Lato = 'Lato, sans-serif',
    Lora = 'Lora, sans-serif',
    Oswald = 'EB Garamond, sans-serif',
    Montserrat = 'Montserrat, sans-serif',
    Merriweather = 'Merriweather, serif',
    PlayfairDisplay = 'Playfair Display, serif',
    Raleway = 'Raleway, sans-serif',
    DancingScript = 'Dancing Script, serif',
    OpenSans = 'Open Sans, sans-serif',
    QuickSand = 'Quicksand, sans-serif',
    GreatVibes = 'Great Vibes, sans-serif'
}

export enum GermanState {
    BadenWuerttemberg = "Baden-Württemberg",
    Bayern = "Bayern",
    Berlin = "Berlin",
    Brandenburg = "Brandenburg",
    Bremen = "Bremen",
    Hamburg = "Hamburg",
    Hessen = "Hessen",
    Niedersachsen = "Niedersachsen",
    MecklenburgVorpommern = "Mecklenburg-Vorpommern",
    NordrheinWestfalen = "Nordrhein-Westfalen",
    RheinlandPfalz = "Rheinland-Pfalz",
    Saarland = "Saarland",
    Sachsen = "Sachsen",
    SachsenAnhalt = "Sachsen-Anhalt",
    SchleswigHolstein = "Schleswig-Holstein",
    Thueringen = "Thüringen"
}

export enum BusinessType {
    SelfEmployed = 'Selbstständig',
    UG = 'UG',
    GmbH = 'GmbH',
    GbR = 'GbR'
}

export enum FileType {
    WEBP = 'webp',
    PNG = 'png',
    JPEG = 'jpeg'
}
export enum CacheStatus {
  Initialised = 'INITIALISED',
  Ready = 'READY',
  Listening = 'LISTENING'
}

export enum PlanName {
    Test = 'test',
    Basic = 'basic',
    Standard = 'standard',
    Premium = 'premium'
}

export enum BillingCycle {
    Monthly = 'monthly',
    Yearly = 'yearly',
  }
  
  export enum PlanStatus {
    Active = 'active',
    Expired = 'expired',
    Pending = 'pending',
  }
  
  export enum PaymentMethod {
    CreditCard = 'Credit Card',
    PayPal = 'PayPal',
    BankTransfer = 'Bank Transfer',
    Other = 'Other',
  }